const initMedia = {
  medias: [],
  isFormLoading: false,
};

export const mediaReducer = (state = initMedia, action: any) => {
  if (action.type === "SET_MEDIA") {
    return {
      ...state,
      medias: action.value,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  return state;
};
